export default __webpack_public_path__ + "static/media/ReportIcon-Stomach-MS.97048fc4.jpg";